import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73513 2.59881C2.92858 2.40234 3.21424 2.32786 3.479 2.40486C10.0938 4.3287 16.3317 7.36782 21.9236 11.3912C22.1194 11.5322 22.2355 11.7587 22.2355 12C22.2356 12.2413 22.1195 12.4679 21.9236 12.6088C16.332 16.6321 10.0945 19.6712 3.48002 21.5952C3.21527 21.6722 2.92962 21.5977 2.73616 21.4013C2.5427 21.2048 2.47263 20.918 2.5537 20.6545L5.21586 12.0001L2.55272 3.3456C2.47163 3.08207 2.54167 2.79529 2.73513 2.59881ZM6.55453 12.75L4.40207 19.7475C10.0198 17.9678 15.34 15.3564 20.1852 12C15.3398 8.64355 10.0192 6.03223 4.40122 4.25256L6.55447 11.25H13.5005C13.9148 11.25 14.2505 11.5858 14.2505 12C14.2505 12.4142 13.9148 12.75 13.5005 12.75H6.55453Z"
        fill={colorValue}
      />
    </svg>
  );
};
